import { Button, Col, Form, Input, InputNumber, Modal, Row, Space } from "antd";

function CampusModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
}) {
  return (
    <Modal
      title={isUpdate ? "Update Campus" : "Add Campus"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        initialValues={{
          ...data,
        }}
        onFinish={(values) => {
          onSave(values);
        }}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Campus Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Campus Name",
                },
              ]}
            >
              <Input placeholder="Campus Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Campus Code"
              name="code"
              rules={[
                {
                  required: true,
                  message: "Please Campus Code",
                },
              ]}
            >
              <Input placeholder="Campus code" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label="City Name"
              name="city"
              rules={[
                {
                  required: true,
                  message: "Please City Name",
                },
              ]}
            >
              <Input placeholder="City Name" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Minimum Booking Time"
              name="minimum_booking_time"
              rules={[
                {
                  required: true,
                  message: "Please minimum booking time",
                },
              ]}
            >
              <InputNumber style={{ width: 200 }} placeholder="minutes" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Minimum Booking Charges"
              name="minimum_booking_charges"
              rules={[
                {
                  required: true,
                  message: "Please minimum booking Charges",
                },
              ]}
            >
              <InputNumber style={{ width: 200 }} placeholder="charges" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default CampusModal;
